import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LinkTo } from 'shared/constants/linkTo';

interface MenuPopUpStyledProps {
    marginTop?: number;
    active: boolean;
}

const ButtonX = styled.div`
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    bottom: 40px;
    left: 16px;

    width: 48px;
    height: 48px;

    background: ${(props) => props.theme.menuOverlay.buttonBackground};
    /* button shadow */

    box-shadow: 0 0 20px rgba(21, 21, 20, 0.39);
    border-radius: 31px;

    z-index: 200;

    svg {
        opacity: ${(props) => props.theme.menuOverlay.buttonOpacity};
        path {
            fill: ${(props) => props.theme.menuOverlay.buttonContent};
        }
    }
`;

const Container = styled(FlexBox)`
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    max-height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
    flex-direction: column;
    top: 0;
    margin: 0;

    padding-left: 16px;
    padding-right: 16px;

    box-sizing: border-box;

    background: ${(props) => props.theme.menuOverlay.backgroundColor};

    z-index: 100000;
`;

const Content = styled(FlexBox)`
    width: 100%;
    height: 100vh;

    flex-direction: column;
`;

const MainTitleSmall = styled.div<MenuPopUpStyledProps>`
    display: flex;
    flex-direction: column;
    max-width: 100% !important;
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-top: ${(props) => props.marginTop}px;
    color: ${(props) =>
        props.active ? props.theme.menuOverlay.textColor : props.theme.menuOverlay.textColorAlternative};
`;

const MainTitleLink = styled.a`
`;

interface MenuPopUpProps {
    isVisible: boolean;
    onClose?: () => void;
    activeTab?: string;
    onSelect?: any;
    showOnlyTabs?: boolean;
    banTabs?: string[];
}

export const PopUpMenu: FC<MenuPopUpProps> = (props) => {
    const history = useHistory();
    const { id }= useParams<{ id: string }>();
    if (!props.isVisible) {
      return null
    }

    const { activeTab, onSelect, showOnlyTabs, banTabs = [''] } = props;

    const getTabsRoute = (str: string) => {
        switch(str) {
            case "main":
                return history.push("/competition/" + id);
            case "projects":
                return history.push("/competition/" + id + "/projects");
            case "jury":
                return history.push("/competition/" + id + "/jury");
            default: return null;
        }
    }

    const tabsMobileWidget = (
        <FlexBox gyMobile={26} directionMobile={'column'}>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('О конкурсе');
                }}
                active={activeTab === 'about'}
            >
                О Конкурсе
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Тайминг');
                }}
                active={activeTab === 'timing'}
            >
                Тайминг
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Условия и требования');
                }}
                active={activeTab === 'terms'}
            >
                Условия и требования
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Жюри и оценивание проектов');
                }}
                active={activeTab === 'marks'}
            >
                Жюри и оценивание проектов
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Вознаграждение');
                }}
                active={activeTab === 'prize'}
            >
                Вознаграждение
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Контакты');
                }}
                active={activeTab === 'contacts'}
            >
                Контакты
            </MainTitleSmall>
        </FlexBox>
    );

    const tabsMobileWidgetCustom = (
        <FlexBox
            gyMobile={26} 
            offsetTop={30} 
            directionMobile={'column'} 
            style={{ flexDirection: "column" }}>
                <MainTitleSmall
                    onClick={() => getTabsRoute("main")}
                    active={activeTab === 'about'}
                >
                    О Конкурсе
                </MainTitleSmall>
                <MainTitleSmall
                    onClick={() => getTabsRoute("projects")}
                    active={activeTab === 'projects'}
                >
                    Проекты
                </MainTitleSmall>
                {banTabs && !banTabs.includes('jury') && (
                    <MainTitleSmall
                        onClick={() => getTabsRoute("jury")}
                        active={activeTab === 'jury'}
                    >
                    Жюри
                    </MainTitleSmall> 
                )} 
        </FlexBox>
    );

    return (
        <Container>
            <Content>
                <FlexBox directionMobile={'column'} offsetBottomMobile={120}>
                    {!showOnlyTabs ? tabsMobileWidget : tabsMobileWidgetCustom}
                </FlexBox>
            </Content>
            <ButtonX onClick={() => props.onClose?.()}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.58203 9.99806L0.804839 17.7752L2.21905 19.1895L9.99624 11.4123L17.7752 19.1913L19.1895 17.7771L11.4105 9.99806L19.1896 2.2189L17.7754 0.804688L9.99624 8.58384L2.2189 0.8065L0.804688 2.22071L8.58203 9.99806Z"
                    />
                </svg>
            </ButtonX>
        </Container>
    );
};
import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LinkTo } from 'shared/constants/linkTo';

interface MenuPopUpStyledProps {
    marginTop?: number;
    active: boolean;
}

const ButtonX = styled.div`
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    bottom: 40px;
    left: 16px;

    width: 48px;
    height: 48px;

    background: ${(props) => props.theme.menuOverlay.buttonBackground};
    /* button shadow */

    box-shadow: 0 0 20px rgba(21, 21, 20, 0.39);
    border-radius: 31px;

    z-index: 200;

    svg {
        opacity: ${(props) => props.theme.menuOverlay.buttonOpacity};
        path {
            fill: ${(props) => props.theme.menuOverlay.buttonContent};
        }
    }
`;

const Container = styled(FlexBox)`
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    max-height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
    flex-direction: column;
    top: 0;
    margin: 0;

    padding-left: 16px;
    padding-right: 16px;

    box-sizing: border-box;

    background: ${(props) => props.theme.menuOverlay.backgroundColor};

    z-index: 100000;
`;

const Content = styled(FlexBox)`
    width: 100%;
    height: 100vh;

    flex-direction: column;
`;

const MainTitleSmall = styled.div<MenuPopUpStyledProps>`
    display: flex;
    flex-direction: column;
    max-width: 100% !important;
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-top: ${(props) => props.marginTop}px;
    color: ${(props) =>
        props.active ? props.theme.menuOverlay.textColor : props.theme.menuOverlay.textColorAlternative};
`;

const MainTitleLink = styled.a`
`;

interface MenuPopUpProps {
    isVisible: boolean;
    onClose?: () => void;
    activeTab?: string;
    onSelect?: any;
    showOnlyTabs?: boolean;
    banTabs?: string[];
}

export const PopUpMenu: FC<MenuPopUpProps> = (props) => {
    const history = useHistory();
    const { id }= useParams<{ id: string }>();
    if (!props.isVisible) {
      return null
    }

    const { activeTab, onSelect, showOnlyTabs, banTabs = [''] } = props;

    const getTabsRoute = (str: string) => {
        switch(str) {
            case "main":
                return history.push("/competition/" + id);
            case "projects":
                return history.push("/competition/" + id + "/projects");
            case "jury":
                return history.push("/competition/" + id + "/jury");
            default: return null;
        }
    }

    const tabsMobileWidget = (
        <FlexBox gyMobile={26} directionMobile={'column'}>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('О конкурсе');
                }}
                active={activeTab === 'about'}
            >
                О Конкурсе
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Тайминг');
                }}
                active={activeTab === 'timing'}
            >
                Тайминг
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Условия и требования');
                }}
                active={activeTab === 'terms'}
            >
                Условия и требования
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Жюри и оценивание проектов');
                }}
                active={activeTab === 'marks'}
            >
                Жюри и оценивание проектов
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Вознаграждение');
                }}
                active={activeTab === 'prize'}
            >
                Вознаграждение
            </MainTitleSmall>
            <MainTitleSmall
                onClick={() => {
                    props.onClose?.();
                    onSelect('Контакты');
                }}
                active={activeTab === 'contacts'}
            >
                Контакты
            </MainTitleSmall>
        </FlexBox>
    );

    const tabsMobileWidgetCustom = (
        <FlexBox
            gyMobile={26} 
            offsetTop={30} 
            directionMobile={'column'} 
            style={{ flexDirection: "column" }}>
                <MainTitleSmall
                    onClick={() => getTabsRoute("main")}
                    active={activeTab === 'about'}
                >
                    О Конкурсе
                </MainTitleSmall>
                <MainTitleSmall
                    onClick={() => getTabsRoute("projects")}
                    active={activeTab === 'projects'}
                >
                    Проекты
                </MainTitleSmall>
                {banTabs && !banTabs.includes('jury') && (
                    <MainTitleSmall
                        onClick={() => getTabsRoute("jury")}
                        active={activeTab === 'jury'}
                    >
                    Жюри
                    </MainTitleSmall> 
                )} 
        </FlexBox>
    );

    return (
        <Container>
            <Content>
                <FlexBox directionMobile={'column'} offsetBottomMobile={120}>
                    {!showOnlyTabs ? tabsMobileWidget : tabsMobileWidgetCustom}
                </FlexBox>
            </Content>
            <ButtonX onClick={() => props.onClose?.()}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.58203 9.99806L0.804839 17.7752L2.21905 19.1895L9.99624 11.4123L17.7752 19.1913L19.1895 17.7771L11.4105 9.99806L19.1896 2.2189L17.7754 0.804688L9.99624 8.58384L2.2189 0.8065L0.804688 2.22071L8.58203 9.99806Z"
                    />
                </svg>
            </ButtonX>
        </Container>
    );
};
